import api from '@/lib/axios';

function unwrap<T>(r: { data: { data?: T } | T }): T {
  const body: any = r.data;
  return (body?.data ?? body) as T;
}

export type LeaveStatus = 0 | 1 | 2;

export interface LeaveRow {
  id: string;
  userId: string;
  userName: string | null;
  reason: string;
  fromDate: string;
  toDate: string;
  status: LeaveStatus;
  days: number;
  createdAt: string;
  leaveDetails: { date: string; type: string }[];
}

export interface LeaveListParams {
  status?: LeaveStatus;
  academicYearId?: string;
  month?: number;
  userId?: string;
}

export interface StaffOption {
  id: string;
  name: string | null;
}

export interface MonthlyLeaveRow {
  month: string;
  allocated: number;
  usedCl: number;
  usedLwp: number;
  usedTotal: number;
  remainingCl: number;
  remainingTotal: number;
}

export interface LeaveReport {
  configured: boolean;
  monthlyAllowedLeaves: number | null;
  academicYearId: string | null;
  userName: string | null;
  months: MonthlyLeaveRow[];
}

/** School tier — scoped by the caller's own tenant via the JWT, no schoolId param needed. Same real tables as OrgLeaveManagementApi. */
export const LeaveManagementApi = {
  list: async (params?: LeaveListParams): Promise<LeaveRow[]> =>
    unwrap(await api.get('/school/leave-management', { params })),

  staffOptions: async (): Promise<StaffOption[]> => unwrap(await api.get('/school/leave-management/staff')),

  /** `userId` is required — real legacy's own /leave/report always scopes to one staff member. */
  report: async (userId: string, academicYearId?: string): Promise<LeaveReport> =>
    unwrap(await api.get('/school/leave-management/report', { params: { userId, academicYearId } })),

  updateStatus: async (id: string, status: LeaveStatus): Promise<LeaveRow> =>
    unwrap(await api.patch(`/school/leave-management/${id}/status`, { status })),
};
